/* tslint:disable member-ordering */
import { Result } from '@mojotech/json-type-validation';
export class CustomCombinators {
    // @ts-ignore
    constructor(decode) {
        this.decode = decode;
    }
    static isValidComponentName() {
        return new CustomCombinators((json) => {
            const componentNameRegex = new RegExp('^[A-Z]+[a-zA-Z0-9]*$');
            if (json && typeof json === 'string' && componentNameRegex.test(json)) {
                return Result.ok(json);
            }
            return Result.err({ message: `Invalid Component name, got ${json}` });
        });
    }
    static isValidNavLink() {
        return new CustomCombinators((json) => {
            const navLinkRegex = new RegExp('/[a-zA-Z0-9-_]*$');
            if (json && typeof json === 'string' && navLinkRegex.test(json)) {
                return Result.ok(json);
            }
            return Result.err({ message: `Invalid link attribute, received ${json}` });
        });
    }
    static isValidFileName() {
        return new CustomCombinators((json) => {
            const fileNameRegex = new RegExp('^[a-zA-Z0-9-_.]*$');
            if (json && typeof json === 'string' && fileNameRegex.test(json)) {
                return Result.ok(json);
            }
            return Result.err({ message: `Invalid link attribute, received ${json}` });
        });
    }
    static isValidElementName() {
        return new CustomCombinators((json) => {
            const fileNameRegex = new RegExp('^[a-zA-Z]+[a-zA-Z0-9-_]*$');
            if (json && typeof json === 'string' && fileNameRegex.test(json)) {
                return Result.ok(json);
            }
            return Result.err({ message: `Invalid link attribute, received ${json}` });
        });
    }
}
//# sourceMappingURL=custom-combinators.js.map